var Grid = function Grid() {
  return {
    gutter: {
      desktop: 24,
      mobile: 16
    },
    container: {
      width: 1600,
      margin: {
        desktop: {
          left: 71,
          right: 71
        },
        mobile: {
          left: 20,
          right: 20
        }
      }
    }
  };
};

export default Grid;